export * from "./try-page.template";
export { TryPageTemplate as default } from "./try-page.template";
